module.exports = __webpack_public_path__ + "static/img/news_program.efa29eb8.png";